import { BrandKit } from "@redotech/redo-model/brand-kit";
import { LoyaltyCompletedEarningRule } from "@redotech/redo-model/customer";
import {
  LoyaltyEarningRule,
  LoyaltyPromotion,
} from "@redotech/redo-model/loyalty/loyalty-definition";
import { LoyaltyPageSettings } from "@redotech/redo-model/loyalty/loyalty-page-builder/definition";
import { createContext } from "react";

export interface LoyaltyCustomer {
  _id: string;
  currentPoints: number;
  currentMoney: number;
  pointsEarned: number;
  moneySpent: number;
  pointsSpent: number;
  earningRuleConditions: { hasReviewed: boolean; hasBirthday: boolean };
  completedEarningRules: LoyaltyCompletedEarningRule[];
}

export enum LoyaltyPageEnvironment {
  BUILDER = "builder",
  STOREFRONT = "storefront",
}

export interface SupportingProductsStatus {
  reviewsEnabled: boolean;
}

export interface LoyaltyPageContext {
  environment: LoyaltyPageEnvironment;
  customer: LoyaltyCustomer | null;
  pageSettings: LoyaltyPageSettings | undefined;
  teamSettings: { brandKit: BrandKit }; // only the subset that's needed; presuming that shopify autocheck will be annoying
  loyaltyEarningRules: LoyaltyEarningRule[];
  loyaltyPromotions: LoyaltyPromotion[];
  completeEarningRule: (
    earningRule: LoyaltyEarningRule,
  ) => Promise<{ success: boolean }>;
  updateBirthday: (birthday: Date) => Promise<{ success: boolean }>;
  supportingProductsStatus: SupportingProductsStatus;
}

export const LoyaltyPageContext = createContext<LoyaltyPageContext | undefined>(
  undefined,
);
